import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../unhcr/facilityInternalRequestApproval/ContextAPI';
import Index from '../unhcr/facilityInternalRequestApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityInternalRequestUnhcrApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-internal-request-unhcr-approval']) return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
